import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { PermissionOverride } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useCreatePermissionOverride = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PermissionOverride, Error, { userId: string; roleId: string }>({
    mutationFn: async (data) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data,
      });
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/permission-overrides`, fetchConfig);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to create Matter-level permission');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.PermissionOverrides, { matterId }]);
      toast.success('Matter-level permission created');
    },
    onError: (error) => {
      toast.error(error.message ?? 'Failed to create Matter-level permission');
    },
  });
};
